import { useEffect, useState } from "react";

/** Tailwind's `max-md` (below 768px wide) as a hook, for texts that differ on phones. */
const PHONE_QUERY = "(max-width: 767.98px)";

const matches = () => {
  try {
    return (
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia(PHONE_QUERY).matches
    );
  } catch {
    return false;
  }
};

export const useIsPhone = () => {
  const [isPhone, setIsPhone] = useState(matches);
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    )
      return;
    const query = window.matchMedia(PHONE_QUERY);
    const update = () => setIsPhone(query.matches);
    update();
    query.addEventListener?.("change", update);
    return () => query.removeEventListener?.("change", update);
  }, []);
  return isPhone;
};
